import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Unit } from 'src/app/form-controls/shared/popovers/unit-popover/unit.popover';
import { UnitQuantity, UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { UserSignature, UserSignatureControl } from 'src/app/form-controls/user-signature/user-signature.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { MedicationAmountUnitV2, MedicationBlueLabelAction, MedicationDoseUnitV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

interface MedicationBlueLabelActionFormGroup {
	dose: FormControl<UnitQuantity | null>;
	amountGiven: FormControl<UnitQuantity | null>;
	approvalOne: FormControl<UserSignature | null>;
	approvalTwo: FormControl<UserSignature | null>;
}

@Component({
    selector: 'app-medication-blue-label-action-controls',
    templateUrl: './medication-blue-label-action-controls.component.html',
    styleUrls: ['../../../common.scss', './medication-blue-label-action-controls.component.scss'],
    imports: [ActionFormComponent, ReactiveFormsModule, UnitQuantityControl, CommonActionControlsComponent, UserSignatureControl],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationBlueLabelActionControlsComponent implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: MedicationBlueLabelAction;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as MedicationBlueLabelAction;
	}

	@Input() form!: FormGroup<MedicationBlueLabelActionFormGroup>;
	@Input() item!: Row | null;

	amountUnits: Unit[] = [
		{ label: MedicationAmountUnitV2.Mg },
		{ label: MedicationAmountUnitV2.Ml },
		{ label: MedicationAmountUnitV2.Ug },
		{ label: MedicationAmountUnitV2.L },
		{ label: MedicationAmountUnitV2.G },
		{ label: MedicationAmountUnitV2.Kg },
		{ label: MedicationAmountUnitV2.Drop },
		{ label: MedicationAmountUnitV2.Graduation },
		{ label: MedicationAmountUnitV2.Tablet },
		{ label: MedicationAmountUnitV2.Capsule },
		{ label: MedicationAmountUnitV2.Spray },
		{ label: MedicationAmountUnitV2.Pump },
		{ label: MedicationAmountUnitV2.Iu },
		{ label: MedicationAmountUnitV2.Na },
	];

	doseUnits: Unit[] = [
		{ label: MedicationDoseUnitV2.Iu },
		{ label: MedicationDoseUnitV2.MgKg },
		{ label: MedicationDoseUnitV2.UgKg },
		{ label: MedicationDoseUnitV2.MgM2 },
		{ label: MedicationDoseUnitV2.IuM2 },
		{ label: MedicationDoseUnitV2.IuKg },
		{ label: MedicationDoseUnitV2.MgAnimal },
		{ label: MedicationDoseUnitV2.UgAnimal },
		{ label: MedicationDoseUnitV2.MlAnimal }
	];

	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.form.addControl('dose', this.formBuilder.control(this.action?.dose ?? null));
		this.form.addControl('amountGiven', this.formBuilder.control(this.action?.amountGiven ?? null));
		this.form.addControl('approvalOne', this.formBuilder.control(this.action?.approvalOne ?? null));
		this.form.addControl('approvalTwo', this.formBuilder.control(this.action?.approvalTwo ?? null));
	}
}